import { IObservable, Subject } from '~/rage/utils';
import { ICharacterNumericPeriodStats, IStats } from '~/shared';
import { BackendService } from '../BackendService';
import { RpcService } from '../RpcService';
import { IStatsService } from './statsServiceTypes';

const INITIAL_NUMERIC_PERIOD_STATS: ICharacterNumericPeriodStats = {
	total: 0,
	yearly: 0,
	monthly: 0,
	daily: 0,
};

export class StatsService implements IStatsService {
	private readonly playTimeStats = new Subject<ICharacterNumericPeriodStats>(
		INITIAL_NUMERIC_PERIOD_STATS,
	);
	private readonly moneySpentStats = new Subject<ICharacterNumericPeriodStats>(
		INITIAL_NUMERIC_PERIOD_STATS,
	);
	private readonly moneyEarnedStats = new Subject<ICharacterNumericPeriodStats>(
		INITIAL_NUMERIC_PERIOD_STATS,
	);

	constructor(
		private readonly rpc: RpcService,
		private readonly backend: BackendService,
	) {}

	public async fetchStats(): Promise<void> {
		await Promise.all([
			this.fetchPlayTimeStats(),
			this.fetchBankSpentStats(),
			this.fetchBankEarnedStats(),
		]);
	}

	private async fetchPlayTimeStats(): Promise<void> {
		const playTimeStats =
			await this.rpc.invokeServer<ICharacterNumericPeriodStats>(
				'playSession:getStats',
			);
		this.playTimeStats.next(playTimeStats);
	}

	public getPlayTimeStats(): IObservable<IStats> {
		return this.playTimeStats;
	}

	private async fetchBankSpentStats(): Promise<void> {
		const moneySpentStats =
			await this.backend.invoke<ICharacterNumericPeriodStats>(
				'bank:getMoneySpentStats',
			);
		this.moneySpentStats.next(moneySpentStats);
	}

	public getMoneySpentStats(): IObservable<IStats> {
		return this.moneySpentStats;
	}

	private async fetchBankEarnedStats(): Promise<void> {
		const moneyEarnedStats =
			await this.backend.invoke<ICharacterNumericPeriodStats>(
				'bank:getMoneyEarnedStats',
			);
		this.moneyEarnedStats.next(moneyEarnedStats);
	}

	public getMoneyEarnedStats(): IObservable<IStats> {
		return this.moneyEarnedStats;
	}
}
